import AnimatedSprite from "slotworks/graphics/animation/animated-sprite";
import Rectangle from "slotworks/utils/geom/rectangle";

export function setTransformRect(displayObject: PIXI.Container | AnimatedSprite, rect: Rectangle | PIXI.Container) {
    displayObject.x = rect.x;
    displayObject.y = rect.y;
    displayObject.width = rect.width;
    displayObject.height = rect.height;
}
